// extracted by mini-css-extract-plugin
export default {"predictiveBox":"_1eK4OFWmMQ4m1mRdRV0tbc","predictiveSearchIcon":"_3CnvanINz6vmOlxxHF13j9"};